<!--
=========================================================
* Vue Argon Dashboard 2 - v3.0.0
=========================================================

* Product Page: https://creative-tim.com/product/vue-argon-dashboard
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
-->
<template>
  <div v-if="currentRouteName != 'Invitation'" v-show="this.$store.state.layout === 'landing'" class="landing-bg h-100 bg-gradient-primary position-fixed w-100"></div>
  <sidenav :custom_class="this.$store.state.mcolor" :class="[this.$store.state.isTransparent, this.$store.state.isRTL ? 'fixed-end' : 'fixed-start']" v-if="this.$store.state.showSidenav && currentRouteName != 'Invitation'" />
  <main class="main-content position-relative max-height-vh-100 h-100 border-radius-lg">
    <!-- nav -->
    <navbar :class="[navClasses]" :textWhite="this.$store.state.isAbsolute ? 'text-white opacity-8' : 'text-white'" :minNav="navbarMinimize" v-if="this.$store.state.showNavbar && currentRouteName != 'Invitation'" />
    <router-view />
    <app-footer v-show="this.$store.state.showFooter" />
    <!-- <configurator
      :toggle="toggleConfigurator"
      :class="[
        this.$store.state.showConfig ? 'show' : '',
        this.$store.state.hideConfigButton ? 'd-none' : ''
      ]"
    /> -->
  </main>
</template>
<script>
  import Sidenav from "./examples/Sidenav";
  // import Configurator from "@/examples/Configurator.vue";
  import Navbar from "@/examples/Navbars/Navbar.vue";
  import AppFooter from "@/examples/Footer.vue";
  import { mapMutations } from "vuex";
  import axios from "axios";

  export default {
    name: "App",
    components: {
      Sidenav,
      // Configurator,
      Navbar,
      AppFooter,
      windowWidth: window.innerWidth,
    },
    methods: {
      ...mapMutations(["toggleConfigurator", "navbarMinimize"]),

      getLogged() {
        return this.$store.state.user.keeplogged;
      },
      keepLogged() {
        if (this.getLogged() != true) {
          this.$router.push({ name: "Signin", query: { redirect: "/signin" } });
        }
      },
      isMobile() {
        // if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        //   return true;
        // } else {
        //   return false;
        // }

        if (this.windowWidth < 360) {
          return true;
        } else {
          return false;
        }
      },
    },
    computed: {
      navClasses() {
        return {
          "position-sticky bg-white left-auto top-2 z-index-sticky": this.$store.state.isNavFixed && !this.$store.state.darkMode,
          "position-sticky bg-default left-auto top-2 z-index-sticky": this.$store.state.isNavFixed && this.$store.state.darkMode,
          "position-absolute px-4 mx-0 w-100 z-index-2": this.$store.state.isAbsolute,
          "px-0 mx-4": !this.$store.state.isAbsolute,
        };
      },
      currentRouteName() {
        return this.$route.name;
      },
    },
    beforeMount() {
      this.$store.state.isTransparent = "bg-transparent";
      console.log(this.$route.path);
    },
    created() {
      let data = {
        user: {
          id: this.$store.state.user.id,
        },
      };

      const routeArr = this.$route.path.split("/");
      let JWTToken = localStorage.getItem("token");
      // console.log(JWTToken);
      return 0;
      if (JWTToken == undefined) {
        if (!this.getLogged()) {
          this.$router.push({ name: "Signin" });
        }
      } else {
        if (routeArr[1] != "Invitation") {
          axios
            .post("https://api.macra.co.id/mavent/admin/keep-login", data, { headers: { Authorization: `Bearer ${JWTToken}` } })
            .then((res) => {
              this.$store.state.user = res.data.dataLogin;
              this.$store.state.user.keeplogged = true;
              this.keepLogged();
            })
            .catch((error) => {
              this.$store.state.user = "";
              if (!this.getLogged()) {
                this.$router.push({ name: "Dashboard" });
              }
            });
        }
      }

      console.log(this.$store.state.user);
    },
  };
</script>

<style>

  .macra-bg {
    background-color:  #58c5c8;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s ease;
  }

  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }

  body {
    overflow-y: scroll;
  }
</style>
